import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const ErrorPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background-color: #f9f9f9;
`;

const ErrorMessage = styled.div`
  margin-bottom: 20px;
  font-size: 1.2rem; /* Reduced font size */
  color: #333;
  text-align: center; /* Centered text */
`;

const AnimationContainer = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const ErrorPage: React.FC = () => {
  return (
    <ErrorPageContainer>
      <ErrorMessage>
        <h4 style={{ fontSize: '1.5rem', marginBottom: '10px' }}>Oops! Something went wrong.</h4>
        <p style={{ fontSize: '1rem' }}>We’re working on it. In the meantime, you can go back to the <a href="/">login page</a> or visit our <a href="/help">help center</a>.</p>
      </ErrorMessage>
      <AnimationContainer />
    </ErrorPageContainer>
  );
};

export default ErrorPage;
